export function lightOrDark(color: string) {
  let r: number, g: number, b: number;
  // Check the format of the color, HEX or RGB?
  if (color.match(/^rgb/)) {
    // If HEX --> store the red, green, blue values in separate variables
    const matches = color.match(/^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/);
    if (matches == null) throw new Error(`Invalid format: ${color}`);
    r = parseInt(matches[1]);
    g = parseInt(matches[2]);
    b = parseInt(matches[3]);
  } else {
    // If RGB --> Convert it to HEX: http://gist.github.com/983661
    const hex = +("0x" + color.slice(1).replace(color.length < 5 ? /./g : "", "$&$&"));

    r = hex >> 16;
    g = (hex >> 8) & 255;
    b = hex & 255;
  }

  // HSP equation from http://alienryderflex.com/hsp.html
  const hsp = Math.sqrt(0.299 * (r * r) + 0.587 * (g * g) + 0.114 * (b * b));

  // Using the HSP value, determine whether the color is light or dark
  if (hsp > 200) {
    return "light";
  } else {
    return "dark";
  }
}
